(function(){
"use strict";
var BASE=(window.FP_QUOTE_BASE||"").replace(/\/+$/,"");
var THREE_URL="https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js";
var host,renderer,scene,camera,mesh,group,reqTimer,curKey="";
var loading=false,dragging=false,lastX=0,lastY=0,spin=0,tilt=0,auto=true;
function ensureThree(cb){
  if(window.THREE){cb();return;}
  if(loading){var iv=setInterval(function(){if(window.THREE){clearInterval(iv);cb();}},80);return;}
  loading=true;var s=document.createElement("script");s.src=THREE_URL;s.onload=function(){cb();};
  s.onerror=function(){var h=document.getElementById("cap3d");if(h)h.innerHTML='<div style="color:#7a8a99;padding:40px;text-align:center;font:12px sans-serif">3D preview unavailable</div>';};
  document.head.appendChild(s);
}
function init(){
  if(renderer)return true;
  host=document.getElementById("cap3d");if(!host)return false;
  var W=host.clientWidth||360,H=host.clientHeight||320;
  renderer=new THREE.WebGLRenderer({antialias:true,alpha:true});renderer.setPixelRatio(window.devicePixelRatio||1);renderer.setSize(W,H);
  host.innerHTML="";host.appendChild(renderer.domElement);
  scene=new THREE.Scene();camera=new THREE.PerspectiveCamera(32,W/H,0.1,5000);
  var d1=new THREE.DirectionalLight(0xffffff,0.95);d1.position.set(0.6,1.3,0.9);scene.add(d1);
  var d2=new THREE.DirectionalLight(0xbcd2ea,0.35);d2.position.set(-0.8,-0.4,-0.7);scene.add(d2);
  scene.add(new THREE.AmbientLight(0xffffff,0.5));
  group=new THREE.Group();scene.add(group);
  var el=renderer.domElement;el.style.cursor="grab";el.style.touchAction="none";
  el.addEventListener("pointerdown",function(e){dragging=true;auto=false;lastX=e.clientX;lastY=e.clientY;try{el.setPointerCapture(e.pointerId);}catch(_){}el.style.cursor="grabbing";});
  el.addEventListener("pointermove",function(e){if(!dragging)return;spin+=(e.clientX-lastX)*0.01;tilt+=(e.clientY-lastY)*0.01;tilt=Math.max(-0.2,Math.min(1.4,tilt));lastX=e.clientX;lastY=e.clientY;});
  el.addEventListener("pointerup",function(){dragging=false;el.style.cursor="grab";});
  window.addEventListener("resize",resize);
  animate();return true;
}
function resize(){if(!renderer||!host)return;var W=host.clientWidth||360,H=host.clientHeight||320;renderer.setSize(W,H);camera.aspect=W/H;camera.updateProjectionMatrix();}
function animate(){requestAnimationFrame(animate);if(!renderer)return;if(auto)spin+=0.006;group.rotation.y=spin;group.rotation.x=tilt;renderer.render(scene,camera);}
function parseSTL(buf){
  var dv=new DataView(buf),n=dv.getUint32(80,true),pos=new Float32Array(n*9),o=84,i,v;
  for(i=0;i<n;i++){o+=12;for(v=0;v<3;v++){pos[i*9+v*3]=dv.getFloat32(o,true);pos[i*9+v*3+1]=dv.getFloat32(o+4,true);pos[i*9+v*3+2]=dv.getFloat32(o+8,true);o+=12;}o+=2;}
  var g=new THREE.BufferGeometry();g.setAttribute("position",new THREE.BufferAttribute(pos,3));g.rotateX(-Math.PI/2);g.computeVertexNormals();g.computeBoundingSphere();return g;
}
function setGeom(g){
  if(mesh){group.remove(mesh);mesh.geometry.dispose();mesh.material.dispose();}
  var mat=new THREE.MeshStandardMaterial({color:0x3a4658,metalness:0.15,roughness:0.7,side:THREE.DoubleSide});
  mesh=new THREE.Mesh(g,mat);
  var c=g.boundingSphere.center;mesh.position.set(-c.x,-c.y,-c.z);
  group.add(mesh);
  var r=g.boundingSphere.radius||60,dist=r/Math.sin(16*Math.PI/180)*1.18;
  camera.position.set(0,dist*0.5,dist*0.86);camera.lookAt(0,0,0);
}
function doFetch(params,key){
  ensureThree(function(){
    if(!init())return;
    var p=Object.assign({},params,{preview:true});
    fetch(BASE+"/cap/stl",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:p})})
    .then(function(r){return r.arrayBuffer();}).then(function(buf){try{setGeom(parseSTL(buf));curKey=key;}catch(e){}});
  });
}
function update(params){
  if(!params||!BASE)return;var key=JSON.stringify(params);if(key===curKey)return;
  clearTimeout(reqTimer);reqTimer=setTimeout(function(){doFetch(params,key);},450);
}
function show(){var h=document.getElementById("cap3d");if(h){h.style.display="block";auto=true;setTimeout(resize,40);}}
function hide(){var h=document.getElementById("cap3d");if(h)h.style.display="none";}
window.FPCap3D={update:update,show:show,hide:hide};
})();
